import { render, staticRenderFns } from "./DeliveryStep.vue?vue&type=template&id=52cb7514&scoped=true&"
import script from "./DeliveryStep.vue?vue&type=script&lang=js&"
export * from "./DeliveryStep.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStep.vue?vue&type=style&index=0&id=52cb7514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb7514",
  null
  
)

export default component.exports